import { render } from "./wDebentureType.vue?vue&type=template&id=31acb7d9&ts=true"
import script from "./wDebentureType.vue?vue&type=script&lang=ts"
export * from "./wDebentureType.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__